import { render, staticRenderFns } from "./hierarchicalPatientTree.vue?vue&type=template&id=18516226&scoped=true&"
import script from "./hierarchicalPatientTree.vue?vue&type=script&lang=js&"
export * from "./hierarchicalPatientTree.vue?vue&type=script&lang=js&"
import style0 from "./hierarchicalPatientTree.vue?vue&type=style&index=0&id=18516226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18516226",
  null
  
)

export default component.exports